// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__jIJix"};
module.exports.__checksum = "3a4a48b27906"
